import { ImportStatsTable, Owner } from 'cargo-chief-commons';

export const automationTransactionsPageStateKey = 'automation-transactions-page';

export interface AutomationTransactionsState {
	usersList: Array<Owner>;
	error: string;
	filters: any[];
	sort: any[];
	loading: boolean;
	transactionsList: ImportStatsTable[];
	total: number;
	totalTransactions: any;
	transactionsThisMonth: any;
	transactionsUsedForPricing: any;
}

export const initialState: AutomationTransactionsState = {
	usersList: [],
	error: null,
	filters: [],
	sort: [],
	loading: true,
	transactionsList: [],
	total: 0,
	totalTransactions: '...',
	transactionsThisMonth: '...',
	transactionsUsedForPricing: '...',
};
